/* @flow */
import { REHYDRATE } from 'redux-persist/lib/constants';
import { Record, List, Map } from 'immutable';
import { ANSWER_QUESTION, FETCH_QUESTIONNAIRE_DATA, SUBMIT_QUESTIONNAIRE } from './actions';
import { start_action, success_action, error_action } from '../../../lib/action_helper';
import type {
  ActionType,
  StateType,
  QuestionnaireDataType,
} from './types';

const StateAnnotation: StateType = {
  questionnaireData: List([]),
  isFetched: false,
  rehydrated: false,
  ui: Map().mergeDeep({
    submit: {
      success: null,
      error: null,
    },
  }),
};

export const InitialState = Record(StateAnnotation, 'healthCheck/InitialState');

export default function reducer(
  state: StateType = new InitialState(),
  action: ActionType,
): StateType {
  if (!(state instanceof InitialState)) return new InitialState(state);
  switch (action.type) {
    default:
      return state;
    case start_action(FETCH_QUESTIONNAIRE_DATA): {
      return state.set('isFetched', false);
    }

    case success_action(FETCH_QUESTIONNAIRE_DATA): {
      const { payload } = action;
      const questionnaireData: QuestionnaireDataType = payload;
      return state
        .set('questionnaireData', List(questionnaireData.map(Map)))
        .set('isFetched', true);
    }

    case ANSWER_QUESTION: {
      const { payload: { question_id, value } } = action;

      const index = state.questionnaireData.findIndex(qa => qa.get('question_id') === question_id);

      return state
        .setIn(['questionnaireData', index, 'result'], value);
    }

    case REHYDRATE: {
      const {
        healthCheck: {
          questionnaireData,
        } = { questionnaireData: [] },
      } = action.payload;

      return state
        .set('rehydrated', true)
        .set('questionnaireData', List(questionnaireData.map(Map)))
        .set('isFetched', true);
    }

    case success_action(SUBMIT_QUESTIONNAIRE): {
      return state
        .setIn(['ui', 'submit', 'success'], action.payload.status)
        .setIn(['ui', 'submit', 'error'], null);
    }

    case error_action(SUBMIT_QUESTIONNAIRE): {
      return state
        .setIn(['ui', 'submit', 'success'], null)
        .setIn(['ui', 'submit', 'error'], action.error);
    }
  }
}
